import React from 'react';
import './Tooltip.css';

const Tooltip = ({ icon, text, children }) => (
  <div className="tooltip-component">
      <div className="tooltip-trigger">{icon}
        <div className="tooltip">
          {children}
        </div>
      </div>
  </div>
)

export default Tooltip;


// WEBPACK FOOTER //
// ./src/components/Tooltip.js